import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../../widgets';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import { allMonedasAction, setActivoMonedasAction } from './MonedasAction';
import FormMonedas from './components/FormMonedas';
import ListadoMonedas from './components/ListadoMonedas';

const MonedasView = () => {
  const dispatch = Redux.useDispatch();

  const monedasStore = Redux.useSelector((state) => state.monedas);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonComponent
          click={async () => {
            await setActivoMonedasAction(dispatch, null);
            setOpenModalForm(true);
          }}
          text="Asignar"
          green
          addIcon
          mr={2}
        />
        <BotonComponent
          click={async () => {
            await setActivoMonedasAction(dispatch, null);
            await allMonedasAction(dispatch, monedasStore.params);
          }}
          disabled={monedasStore.all.length === 0 || monedasStore.loadingAll}
          white
          refreshIcon
          text={monedasStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
        />
      </Grid>
      <Grid item md={12}>
        <ListadoMonedas setOpenModalForm={(value) => setOpenModalForm(value)} />
      </Grid>
      <ModalComponent
        id="modalFormMonedas"
        maxWidth="sm"
        title={
          monedasStore.activo
            ? `Editar ${monedasStore.activo.nombre}`
            : 'Nueva moneda del sistema'
        }
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormMonedas
          activo={monedasStore.activo}
          setOpenModalForm={(value) => setOpenModalForm(value)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default MonedasView;
